import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, apiFetch } from 'API/apiClient';
import type { IUser } from 'types/IUser';
import type { RootState } from 'store/store';

export const fetchUsers = createAsyncThunk<IUser[], undefined, { rejectValue: ApiError; state: RootState }>('users/fetchAll', async (_, { rejectWithValue }) => {
  return await apiFetch<IUser[]>('/users', {}, rejectWithValue);
});

export const fetchUsersByLottery = createAsyncThunk<IUser[], number, { rejectValue: ApiError; state: RootState }>('users/fetchByLottery', async (lotteryId, { rejectWithValue }) => {
  return await apiFetch<IUser[]>(`/users/lottery/${lotteryId}`, {}, rejectWithValue);
});

export const fetchUser = createAsyncThunk<IUser, number, { rejectValue: ApiError; state: RootState }>('users/fetchOne', async (id, { rejectWithValue }) => {
  return await apiFetch<IUser>(`/users/${id}`, {}, rejectWithValue);
});

export const createUser = createAsyncThunk<IUser, Partial<IUser> & { password: string }, { rejectValue: ApiError; state: RootState }>('users/create', async (data, { rejectWithValue }) => {
  return await apiFetch<IUser>('/users', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const updateUser = createAsyncThunk<IUser, { id: number; data: Partial<IUser> & { permissionId?: number } }, { rejectValue: ApiError; state: RootState }>('users/update', async ({ id, data }, { rejectWithValue }) => {
  return await apiFetch<IUser>(`/users/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const deleteUser = createAsyncThunk<void, number, { rejectValue: ApiError; state: RootState }>('users/delete', async (id, { rejectWithValue }) => {
  return await apiFetch<void>(`/users/${id}`, { method: 'DELETE' }, rejectWithValue);
});
